import { FC } from 'react';

import {
  BlockHeader,
  Collapse,
  CollapseItem,
} from '../../../../../shared/lib/ui';
import S from './Faq.module.scss';
import {
  OFFER_LINK,
  PAYMENTS_POLICY_LINK,
  SITES_MODERATION_POLICY_LINK,
} from '../../../../../shared/lib/constants/links';
import { Trans, useTranslation } from 'react-i18next';

export const Faq: FC = () => {
  const { t } = useTranslation();

  return (
    <section className={S.Faq}>
      <BlockHeader
        block={t('webmaster.faq_section.title')}
        title={t('webmaster.faq_section.subtitle')}
      />
      <Collapse type="multiple">
        <CollapseItem
          header={t('webmaster.faq_section.question_1.title')}
          value="1"
        >
          <Trans t={t} i18nKey="webmaster.faq_section.question_1.description">
            <a href={SITES_MODERATION_POLICY_LINK}></a>.
          </Trans>
        </CollapseItem>
        <CollapseItem
          header={t('webmaster.faq_section.question_2.title')}
          value="2"
        >
          <Trans t={t} i18nKey="webmaster.faq_section.question_2.description">
            <a href="mailto:analytics@adwile.com"></a>.
          </Trans>
        </CollapseItem>
        <CollapseItem
          header={t('webmaster.faq_section.question_3.title')}
          value="3"
        >
          {t('webmaster.faq_section.question_3.description')}
        </CollapseItem>
        <CollapseItem
          header={t('webmaster.faq_section.question_4.title')}
          value="4"
        >
          <Trans t={t} i18nKey="webmaster.faq_section.question_4.description">
            <a href={OFFER_LINK}></a>.
          </Trans>
        </CollapseItem>
        <CollapseItem
          header={t('webmaster.faq_section.question_5.title')}
          value="5"
        >
          <Trans t={t} i18nKey="webmaster.faq_section.question_5.description">
            <a href={PAYMENTS_POLICY_LINK}></a>.
          </Trans>
        </CollapseItem>
        <CollapseItem
          header={t('webmaster.faq_section.question_6.title')}
          value="6"
        >
          {t('webmaster.faq_section.question_6.description')}
        </CollapseItem>
      </Collapse>
    </section>
  );
};
